"use client";

import { Flex, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";

export const Logo = ({ withText = true }: { withText?: boolean }) => {
  // Use a simple local state to handle reduced motion if the hook is unavailable
  // or default to false (animations enabled)
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useEffect(() => {
    // Standard browser API for reduced motion preference
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    setPrefersReducedMotion(mediaQuery.matches);

    const handleChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  // More subtle animation: gentle vertical lift + opacity shift
  const animationStyles = !prefersReducedMotion ? (
    <style jsx global>{`
      @keyframes logoBarRise {
        0%, 100% {
          opacity: 1;
          transform: translateY(0);
        }
        50% {
          opacity: 0.75;
          transform: translateY(-0.5px);
        }
      }
    `}</style>
  ) : null;

  return (
    <Flex align="center" gap={3}>
      {animationStyles}
      <svg width="32px" height="32px" viewBox="0 0 32 32" fill="none">
        {/* Primary blue: matches CTA color */}
        <rect width="32" height="32" rx="8" fill="#0071E3" />

        {/* Ranking bars: precise positioning, refined stroke, progressive heights */}
        <path
          d="M9 22V16.5"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          style={{
            animation: !prefersReducedMotion ? "logoBarRise 2s ease-in-out 0s infinite" : "none"
          }}
        />
        <path
          d="M16 22V12"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          style={{
            animation: !prefersReducedMotion ? "logoBarRise 2s ease-in-out 0.15s infinite" : "none"
          }}
        />
        <path
          d="M23 22V7.5"
          stroke="white"
          strokeWidth="2.5"
          strokeLinecap="round"
          style={{
            animation: !prefersReducedMotion ? "logoBarRise 2s ease-in-out 0.3s infinite" : "none"
          }}
        />
      </svg>
      {withText && (
        <Text
          fontSize="20px"
          fontWeight="600"
          color="var(--color-text-primary)"
          letterSpacing="-0.025em"
        >
          OTAlytics
        </Text>
      )}
    </Flex>
  );
};
